import { render } from "./OrdersManagerSettingsList.vue?vue&type=template&id=aa80f19c"
import script from "./OrdersManagerSettingsList.vue?vue&type=script&lang=js"
export * from "./OrdersManagerSettingsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__